import { generateApis, generateDefaultSite, isLocalhost, parseBool } from '@/utils';

import type { EnvironmentConfig, ParsedEnvVariables, SiteConfig } from './config.type.ts';

export const mapEnvironmentToConfig = (config: EnvironmentConfig): ParsedEnvVariables => {
  let defaultSite: SiteConfig;
  const imageTag = config.image_tag;
  const clusterName = config.cluster_name;
  const env = config.env;
  const portableMode = parseBool(config.portable_mode);
  const videoRecallDisabled = parseBool(config.video_recall_disabled);
  if (portableMode) {
    return {
      imageTag,
      env,
      clusterName,
      portableMode,
      videoRecallDisabled,
      defaultSite: undefined,
    };
  }
  if (isLocalhost()) {
    try {
      defaultSite = JSON.parse(config.defaultSite as string) as SiteConfig;
      return {
        imageTag,
        clusterName,
        env,
        portableMode,
        videoRecallDisabled,
        defaultSite: {
          ...defaultSite,
          apis: generateApis(defaultSite, env, portableMode),
        },
      };
    } catch (e) {
      console.error('Cannot parse defaultSite:', e);
      throw e;
    }
  } else {
    return {
      imageTag,
      env,
      clusterName,
      portableMode,
      videoRecallDisabled,
      defaultSite: generateDefaultSite(undefined, env, portableMode),
    };
  }
};
